/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_TitleInputs */

const fr_install_title = /** @type {(inputs: Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intégrer le widget sur votre site`)
};

const en_install_title = /** @type {(inputs: Install_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Integrate the widget on your site`)
};

/**
* | output |
* | --- |
* | "Integrate the widget on your site" |
*
* @param {Install_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const install_title = /** @type {((inputs?: Install_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_install_title(inputs)
	return en_install_title(inputs)
});